import { useEffect, useState, type FormEvent } from 'react';
import { Heart, Send } from 'lucide-react';
import { supabase } from '@/lib/supabase';

type Message = { id: string; author_name: string; content: string; created_at: string };

export default function CadernoSection() {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const loadMessages = async () => {
    const { data, error } = await supabase
      .from('valentina_guestbook_messages')
      .select('id,author_name,content,created_at')
      .order('created_at', { ascending: false });
    if (!error) setMessages((data as Message[]) || []);
    setLoading(false);
  };

  useEffect(() => { void loadMessages(); }, []);

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!name.trim() || !message.trim() || sending) return;
    const formData = new FormData(event.currentTarget);
    if (String(formData.get('contact_alt') || '').trim()) { setStatus('success'); return; }

    setSending(true);
    setStatus('idle');
    const { error } = await supabase.from('valentina_guestbook_messages').insert({
      author_name: name.trim(), content: message.trim(),
    });
    if (error) setStatus('error');
    else {
      setName(''); setMessage(''); setStatus('success');
      await loadMessages();
    }
    setSending(false);
  };

  return (
    <section id="recados" className="guestbook block">
      <div className="section-title"><i /><h2>CADERNO DE RECADOS</h2><i /><Heart size={12} fill="currentColor" /></div>
      <p className="guestbook-intro">Deixe uma mensagem especial para a Valentina guardar para sempre.</p>
      <div className="guestbook-layout">
        <form className="guestbook-form" onSubmit={submit}>
          <span className="guestbook-tape" aria-hidden="true" />
          <h3>Escreva seu recado</h3>
          <input className="hp-field" name="contact_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
          <label htmlFor="guestbook-name">Seu nome</label>
          <input id="guestbook-name" value={name} onChange={(event) => setName(event.target.value)} maxLength={60} required placeholder="Digite seu nome" />
          <label htmlFor="guestbook-message">Sua mensagem</label>
          <textarea id="guestbook-message" value={message} onChange={(event) => setMessage(event.target.value)} maxLength={500} required placeholder="Escreva algo especial para a Valentina..." />
          <small className="guestbook-counter">{message.length}/500</small>
          <button type="submit" disabled={sending}><Send size={16} /> {sending ? 'ENVIANDO...' : 'ENVIAR RECADO'}</button>
          {status === 'success' && <p className="guestbook-success"><Heart size={13} fill="currentColor" /> Obrigada pelo carinho! Seu recado foi registrado.</p>}
          {status === 'error' && <p className="guestbook-error">Não foi possível enviar agora. Tente novamente em instantes.</p>}
        </form>
        <div className="guestbook-messages" aria-live="polite">
          {loading ? <p className="guestbook-empty">Carregando recados...</p> : messages.length === 0 ? <p className="guestbook-empty">Seja a primeira pessoa a deixar um recado.</p> : messages.map((item, index) => (
            <article className={`guestbook-note note-${index % 3}`} key={item.id}>
              <Heart size={12} fill="currentColor" /><p>“{item.content}”</p>
              <footer><strong>{item.author_name}</strong><small>{new Date(item.created_at).toLocaleDateString('pt-BR')}</small></footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
